/* global s */
'use strict';

class HeroMobileRecharge {
	constructor() {
		// console.log('HeroMobileRechargeV4');
		this.initial_state = s.options._hero_mobile_recharge_options.state;
		this.location = s.options._hero_mobile_recharge_options.location;
		this.base_url = s.options._hero_mobile_recharge_options.base_url;
		this.operators_per_row = s.options._hero_mobile_recharge_options.operators_per_row;
		this.selected_country = s.options._hero_mobile_recharge_options.selected_country;
		this.selected_operator = s.options._hero_mobile_recharge_options.selected_operator;
		this.add_tello_as_operator = s.options._hero_mobile_recharge_options.add_tello_as_operator;
		this.mr_offers = s.options._hero_mobile_recharge_options.mr_offers;
		this.section_carousel_slides_per_view = s.options._hero_mobile_recharge_options.section_carousel_slides_per_view;
		this.hero_operator_countries_length = s.options._hero_mobile_recharge_options.hero_operator_countries_length;
		this.product_type = s.options._hero_mobile_recharge_options.product_type || '';

		this.fields = {
			holder: document.querySelector('#buy-mr-holder'),
			country: document.querySelector('#country'),
			country_input: document.querySelector('[data-country-search-input]'),
			operator_holder: document.querySelector('#operator-holder'),
			operator_content: document.querySelector('#operator-content'),
			operator_options_content: document.querySelector('#operator-options-content'),

			account_fields_holder: document.querySelector('#account-fields-holder'),
			account_fields_content: document.querySelector('#account-fields-content'),

			submit_holder: document.querySelector('#submit-holder'),
			submit_button: document.querySelector('#buy-button-mr'),
			submit_message_holder: document.querySelector('#submit-message-holder')
		}

		this.promise = {};

		this.initial_preselect_operator_group = false;

		this.mr = new MobileRechargeV4({
			'defaults': {
				'operators_per_row': this.operators_per_row
			},
			'state': this.initial_state,
			'base_url': this.base_url,
			'location': this.location,
			'fields': this.fields,
			'add_tello_as_operator': this.add_tello_as_operator,
			'product_type': this.product_type,
		});

		this.hero_carousel_offer = undefined;

		this.pageEvents();
		this.handleCarousels();
	}

	pageEvents() {
		const _this = this;

		// Handle initial_state changeCountry
		if (_this.initial_state?.country?.code) {
			_this.changeCountry(_this.initial_state.country.code);
		}

		// Bind change event on country select
		if (_this.fields.country) {
			_this.fields.country.addEventListener('change', (event) => {
				_this.changeCountry(event.target.value);
			});
		}

		if (_this.fields.country_input && _this.fields.country_input.dataset.countrySearchInput === '1') {
			const observerOptions = { attributes: true, attributeFilter: ["data-country-code"] };

			const callback = (mutationList, observer) => {
				for(const mutation of mutationList){
					if (mutation.type === "attributes" && mutation.attributeName === "data-country-code") {
						_this.changeCountry(mutation.target.dataset.countryCode);
					}
				}
			}

			const observer = new MutationObserver(callback);
			observer.observe(_this.fields.country_input, observerOptions);
		}

		const hero_country_selector = document.getElementById('hero_country_selector');
		if (hero_country_selector) {
			hero_country_selector.addEventListener('change', () => {
				let country_name = hero_country_selector.options[hero_country_selector.selectedIndex].textContent;
				let operator_name = hero_country_selector.options[hero_country_selector.selectedIndex].getAttribute('data-operator_name');
				let operator_group = hero_country_selector.options[hero_country_selector.selectedIndex].getAttribute('data-operator_group');
				let last_segment = window.location.pathname.replace(/\/$/, '').split('/').pop();
				let go_to_group = operator_group && last_segment.toLowerCase() === operator_group.toLowerCase() && operator_group.toLowerCase() !== operator_name.toLowerCase();

				if (country_name !== s.it('SELECT_COUNTRY')) {
					let hero_button_url = s.url(
						(this.product_type ? '/buy/' + this.product_type + '/' : '/buy/mobile_recharge/')
						+ encodeURIComponent(country_name)
						+ (go_to_group ? '?op_group=' + encodeURIComponent(operator_group) : '/' + encodeURIComponent(operator_name))
					);
					_this.fields.submit_button.setAttribute('href', hero_button_url);
					_this.fields.submit_button.classList.remove('disabled');
				} else {
					_this.fields.submit_button.classList.add('disabled');
				}
				_this.mr.emptyElement(_this.fields.submit_message_holder);
			});

			if (_this.location === 'send_page' && !_this.selected_country && _this.hero_operator_countries_length === 1) {
				hero_country_selector.dispatchEvent(new Event('change'));
			}
		}

		// Bind operators click event
		document.addEventListener('click', (event) => {
			const operator_button = event.target.closest('.operator_button');
			if (operator_button) {
				_this.bindOperatorEvent(operator_button);
				_this.mr.emptyElement(_this.fields.submit_message_holder);
			}
		});

		// Handle click on disabled submit button and show warning messages
		if (_this.fields.submit_button && _this.fields.submit_message_holder) {
			_this.fields.submit_button.addEventListener('click', (event) => {
				if (event.target.classList.contains('disabled')) {
					event.preventDefault();
					_this.mr.updateSubmitMessage();
				}
			});
		}
	}

	/**
	 * Handles account fields events.
	 */
	bindAccountFieldsEvents() {
		const _this = this;
		if (_this.fields.account_fields_holder) {
			const inputs = _this.fields.account_fields_content.querySelectorAll('[data-account-field-key]');

			inputs.forEach((element) => {
				element.addEventListener('input', (event) => {
					const key = event.target.getAttribute('data-account-field-key');
					const value = event.target.value;

					_this.changeAccountField(key, value);
				});
			});
		}
	}

	/**
	 * Handles the change country event.
	 * @param {String} 	country_code
	 */
	changeCountry(country_code) {
		// console.log('HeroMobileRecharge changeCountry(%o)', country_code);
		const _this = this;
		if (_this.location === 'hero') {
			const hero_features = document.querySelector('#mr-home-features');

			if (country_code === '') {
				_this.mr.hideElement(_this.fields.operator_holder);
				_this.mr.showElement(hero_features);
			} else {
				_this.mr.showElement(_this.fields.operator_holder);
				_this.mr.hideElement(hero_features);
			}
		}

		_this.mr.changeCountry(country_code)
			.then((response) => {
				if (response && response.operator_groups) {
					_this.mr.updateCountryOperators(response.operator_groups);

					if (!_this.showOperatorGroup()) {
						return;
					}

					if (_this.location === 'send_page' && response.operator_groups.length >= 3) {
						_this.mr.createOperatorGroupBackButton();
					}

					if (_this.location === 'hero_target' && document.querySelector('#all_operators_holder')) {
						_this.createAllAvailableOperators(response.operator_groups);
					}
				}

				if (_this.initial_state.operator.id) {
					// open initial operator
					_this.changeOperator(_this.initial_state.operator.id);
				}

				_this.updateSubmitButtonLink(response);

				if (_this.location === 'hero' && typeof _this.hero_carousel_offer !== undefined) {
					_this.updateHeroCarousel(response.state.country.code);
				}
			})
			.catch((error) => {
				throw error;
			});
	}

	/**
	 * Handles the change operator event.
	 * @param {String} 	operator_id
	 */
	changeOperator(operator_id) {
		// console.log('HeroMobileRecharge changeOperator(%o)', operator_id);
		const _this = this;
		const choose_another_operator = _this.fields.operator_content.querySelector('#choose_another_operator');

		if (choose_another_operator) {
			choose_another_operator.classList.remove('active', 'on_active_display_block');
		}

		_this.mr.changeOperator(operator_id)
			.then((response) => {
				const country = response.state.country;
				const operator = response.state.operator;

				if (_this.location === 'send_page') {
					if (choose_another_operator) {
						choose_another_operator.classList.add('active', 'on_active_display_block');
					}

					_this.bindAccountFieldsEvents();

					_this.mr.emptyElement(_this.fields.submit_message_holder);

					// update url
					let new_url = _this.base_url;
					if (typeof country.name !== 'undefined') {
						new_url += `/${encodeURIComponent(country.name)}`;
					}
					if (typeof operator.name !== 'undefined') {
						new_url += `/${encodeURIComponent(operator.name)}`;
					}
					window.history.replaceState(response.state, 'Title', s.url(new_url, {}));

					if (_this.mr.state.supplier_operator_fields.length) {
						_this.mr.state.supplier_operator_fields.forEach(field => {
							if (_this.mr.state.account_fields[field.field_key].value) {
								_this.changeAccountField(field.field_key, _this.mr.state.account_fields[field.field_key].value);
							}
						});
					}
				}

				_this.updateSubmitButtonLink(response);
			})
			.catch((error) => {
				throw error;
			});
	}

	/**
	 * Handles the change account field event.
	 * @param {String} 	account_field_key
	 * @param {String} 	account_field_value
	 */
	changeAccountField(account_field_key, account_field_value) {
		// console.log('HeroMobileRecharge changeAccountField key: (%o), value:(%o)', account_field_key, account_field_value);
		this.mr.emptyElement(this.fields.submit_message_holder);

		this.promise.change_account_field = this.mr.changeAccountField(account_field_key, account_field_value);

		this.promise.change_account_field.then((response) => {
			this.updateSubmitButtonLink(response);
			if (this.fields.submit_button) {
				this.fields.submit_button.classList.remove('disabled');
			}
		})
			.catch(() => {
				if (this.fields.submit_button) {
					this.fields.submit_button.classList.add('disabled');
				}
			});
	}

	/**
	 * Handles the changes for the submit button.
	 * @param {Object} 	response
	 */
	updateSubmitButtonLink(response) {
		if (this.fields.submit_holder && this.fields.submit_button) {
			let params = '';
			let new_url = this.product_type ? '/buy/' + this.product_type + '' : '/buy/mobile_recharge';
			let field;
			this.mr.showElement(this.fields.submit_holder);
			this.fields.submit_button.setAttribute('data-country-name', '');
			this.fields.submit_button.setAttribute('data-operator-name', '');

			if(this.fields.country_input && this.fields.country_input.dataset.countrySearchInput === '1'){
				let countryName = this.fields.country_input.getAttribute('data-country-name');
				if (response.state.country && typeof countryName === 'string') {
					new_url += `/${encodeURIComponent(countryName)}`;
					this.fields.submit_button.setAttribute('data-country-name', countryName);
				}
			} else {
				if (response.state.country && typeof response.state.country.name === 'string') {
					new_url += `/${encodeURIComponent(response.state.country.name)}`;
					this.fields.submit_button.setAttribute('data-country-name', response.state.country.name);
				}
			}

			if (response.state.operator && typeof response.state.operator.name === 'string') {
				new_url += `/${encodeURIComponent(response.state.operator.name)}`;
				this.fields.submit_button.setAttribute('data-operator-name', response.state.operator.name);
			}

			if (this.mr.state.account_fields.types.includes('phone') && response.state.supplier_operator_fields.length > 0) {
				field = response.state.supplier_operator_fields.find((field) => field.type === 'phone');
			}

			if (this.mr.state.account_fields.types.includes('nauta') && response.state.supplier_operator_fields.length > 0) {
				field = response.state.supplier_operator_fields.find((field) => field.type === 'nauta');
			}

			if (field && field.field_key) {
				const field_value = response.state.account_fields[field.field_key].value;

				if (field_value) {
					params = {
						'destination': field_value
					};
				}
			}

			this.fields.submit_button.setAttribute('href', s.url(new_url, params));
		}
	}

	/**
	 * Handles operator events.
	 * @param {Object} 	operator_button
	 */
	bindOperatorEvent(operator_button) {
		const button_parent = operator_button.closest('.operator');

		if (!button_parent.classList.contains('active')) {
			switch (operator_button.type) {
				case 'button':
					this.handleOperatorButtonEvent(operator_button);
					break;

				default:
					// if no type, default to a div selector equivalent for a group selector
					this.handleOperatorGroupEvent(operator_button);
					break;
			}
			this.mr.scrollToTarget('#operators-scroll-target');
		}
	}

	/**
	 * Handles operator events.
	 * @param {Object} 	operator_button
	 */
	handleOperatorButtonEvent(operator_button) {
		const operator_buttons_from_group = this.fields.operator_options_content.querySelectorAll('button.operator_button');

		if (operator_buttons_from_group) {
			const hero_subtitle = document.querySelector('#hero_subtitle');
			for (let element of operator_buttons_from_group) {
				element.closest('.operator').classList.remove('active');
				element.closest('.operator').classList.add('inactive');
			}

			const selected_operator_el = operator_button.closest('.operator');
			if (selected_operator_el) {
				selected_operator_el.classList.remove('inactive');
				selected_operator_el.classList.add('active');
			}

			if (hero_subtitle) {
				if (this.base_url == '/send/recharge') {
					const operator_name = operator_button.getAttribute('data-country');
					hero_subtitle.innerHTML = s.it('RECHARGE_YOUR_LOVED_ONE_MOBILE', {'operator': operator_name});
				} else if (this.base_url == '/send/gift_cards') {
					const operator_name = operator_button.getAttribute('data-operator');
					const country_name = operator_button.getAttribute('data-country');
					hero_subtitle.innerHTML = s.it('RECHARGE_YOUR_LOVED_ONE_MOBILE', {'operator': operator_name, 'country': country_name });
				}
			}
		}

		this.changeOperator(operator_button.value);
	}

	/**
	 * Handles operator group events.
	 * @param {Object} 	operator_button
	 */
	handleOperatorGroupEvent(operator_button) {
		const hero_subtitle = document.querySelector('#hero_subtitle');
		const operator_group_name = operator_button.getAttribute('data-operator-group');
		const operator_groups = this.mr.cache[this.mr.state.country.code];
		const operator_group = this.mr.findOperatorGroup(operator_groups, operator_group_name);
		let new_url;

		if (operator_group && hero_subtitle) {
			hero_subtitle.innerHTML = s.it('RECHARGE_YOUR_LOVED_ONE_MOBILE', {'operator': operator_group.group});
		}

		if (operator_group && operator_group.operators.length > 1) {
			if (this.fields.submit_button) {
				if(this.fields.country_input && this.fields.country_input.dataset.countrySearchInput === '1'){
					let country_name = this.fields.country_input.getAttribute('data-country-name');
					new_url = `${this.base_url}/${encodeURIComponent(country_name)}/?op_group=${encodeURIComponent(operator_group_name)}`;
				} else {
					new_url = `${this.base_url}/${encodeURIComponent(this.mr.state.country.name)}/?op_group=${encodeURIComponent(operator_group_name)}`;
				}
				
				this.fields.submit_button.setAttribute('href', s.url(new_url));

				if (this.location === 'send_page') {
					window.history.replaceState(this.mr.state, 'Title', s.url(new_url, {}));
				}
			}

			this.mr.hideElement(this.fields.operator_content);
			this.mr.hideElement(this.fields.account_fields_holder);
			this.mr.updateOperatorGroup(operator_group);
		}
	}

	/**
	 * Handles display of the operator group.
	 * @return {Boolean}
	 */
	showOperatorGroup() {
		try {
			this.mr.showElement(this.fields.operator_content);
			this.mr.hideElement(this.fields.operator_options_content);

			const url_params = new URLSearchParams(window.location.search);
			const selected_op_group = url_params.get('op_group');

			if (!this.initial_preselect_operator_group && selected_op_group) {
				// Preselect operator group from query string
				// URL is like this: /send/recharge/United%20States?op_group=Lyca
				this.initial_preselect_operator_group = true;
				this.mr.preselectOperatorGroup(selected_op_group);
				this.mr.showElement(this.fields.submit_holder);
				return false;
			}

			if (this.initial_state.operator.id) {
				// Preselect operator group and operator from initial state
				// URL is like this: /send/recharge/United%20States/Lyca%20National%20Plans
				const operator_groups = this.mr.cache[this.mr.state.country.code];
				const operator_group = this.mr.findOperatorGroupByOperatorID(operator_groups, this.initial_state.operator.id);

				if (operator_group) {
					this.mr.preselectOperatorGroup(operator_group.group, this.initial_state.operator.id);
				}
			}

			return true;
		} catch (error) {
			console.error('Error on showOperatorGroup', error);
			return true;
		}
	}

	/**
	 * Handles carousels.
	 */
	handleCarousels() {
		if (this.location === 'hero' && !this.mr.checkEmptyObject(this.mr_offers)) {
			this.initiateHeroCarousel();
		}

		if (this.location === 'send_page') {
			this.initiateSectionCarousel(this.section_carousel_slides_per_view);
		}
	}

	/**
	 * Initiate hero carousel.
	 */
	initiateHeroCarousel() {
		this.hero_carousel_offer = new Glide('#hero-glide', {
			type: 'carousel',
			direction: s.options.user_language_direction,
			keyboard: false,
			classes: {
				cloneSlide: 'glide-slide--clone',
				activeNav: 'glide-bullet--active',
				activeSlide: 'glide-slide--active',
				disabledArrow: 'glide-arrow--disabled'
			}
		})
			.mount()
			.play(4000)
			.on('run', () => {
				const countries = document.querySelectorAll('.worldmap-country');
				const slides = document.querySelectorAll('#hero-glide .glide-slide:not(.glide-slide--clone)');
				const current_slide = slides[this.hero_carousel_offer.index];
				const current_slide_country_code = current_slide.getAttribute('data-country_code');

				if (countries) {
					countries.forEach((country) => {
						country.style.display = 'none';
					});
				}
				document.querySelector(`.worldmap-country[country-code='${current_slide_country_code}']`).style.display = '';
			});
	}

	/**
	 * Update hero world map country on carousel changes.
	 * @param {String} 	country_code
	 */
	updateHeroCarousel(country_code) {
		if (country_code) {
			const slides = document.querySelectorAll('#hero-glide .glide-slide:not(.glide-slide--clone)');
			let country_slide_index = 0;
			let glide_promo_continue = true;

			slides.forEach((slide, index) => {
				const slide_country_code = slide.getAttribute('data-country_code');
				if (slide_country_code === country_code && glide_promo_continue) {
					country_slide_index = index;
					glide_promo_continue = false;

					document.querySelectorAll('.worldmap-country').forEach((element) => {
						element.style.display = 'none';
					});
					document.querySelector(`.worldmap-country[country-code='${slide_country_code}']`).style.display = '';
				}
			});

			if (!glide_promo_continue) {
				this.hero_carousel_offer.update({
					startAt: country_slide_index
				}).play(4000);
			}
		}
	}

	/**
	 * Initiate "promotions" page section carousel.
	 * @param {Number} 	slidesPerView
	 * @return {Object}
	 */
	initiateSectionCarousel(slidesPerView) {
		let glide_carousel = new Glide('.glide_carousel', {
			type: 'carousel',
			direction: s.options.user_language_direction,
			keyboard: false,
			startAt: 0,
			perView: slidesPerView,
			breakpoints: {
				576: {
					perView: 1
				},
				768: {
					perView: 3
				}
			}
		});
		glide_carousel.mount();

		return glide_carousel;
	}

	/**
	 * Create the "all available operators" page section.
	 * @param {Object} 	operator_groups
	 */
	createAllAvailableOperators(operator_groups) {
		const all_operators_holder = document.querySelector('#all_operators_holder')

		for (let group_name in operator_groups) {
			if (operator_groups.hasOwnProperty(group_name)) {
				const group_details = operator_groups[group_name];
				const operator_for_section = document.createElement('div');
				const operator_link = document.createElement('a');
				const operator_image_holder = document.createElement('div');
				const operator_image = document.createElement('img');
				const operator_text = document.createElement('div');
				const operator_name = group_details.operators.length > 1 ? group_details.group : group_details.name;
				const operator_href = `${(this.product_type ? '/buy' + this.product_type : '/buy/mobile_recharge')}/${encodeURIComponent(s.options.preferred_destination)}/${encodeURIComponent(group_details.name)}`;

				if (all_operators_holder.querySelector('.spinner')) {
					all_operators_holder.querySelector('.spinner').style.display = 'none';
				}

				operator_image.setAttribute('src', s.url(`/images/operators/${encodeURIComponent(group_details.logo)}.jpg`));
				operator_image.alt = s.h(operator_name);

				operator_image_holder.classList.add('operator-logo', 'd-flex', 'flex-grow-1', 'justify-content-center', 'align-items-center');
				operator_image_holder.style.minHeight = '58px';
				operator_image_holder.appendChild(operator_image);

				operator_text.classList.add('operator-name', 'color-black', 'mt-10');
				operator_text.innerText = s.it('MR_HOMEPAGE_RECHARGE_OPERATOR', {'operator': operator_name});

				operator_link.classList.add('operator-link', 'd-flex', 'flex-column', 'text-center');
				operator_link.setAttribute('href', s.url(operator_href));
				operator_link.appendChild(operator_image_holder);
				operator_link.appendChild(operator_text);

				operator_for_section.classList.add('operator', 'd-flex', 'align-items-center', 'mb-50');
				operator_for_section.appendChild(operator_link);

				all_operators_holder.append(operator_for_section);
			}
		}
	}
}
